/* ------------------------------------------------------------------
   Pure RV & Co — homepage redesign (v2) behaviour
   Only the "Build your own bundle" panel needs script. Everything else on
   this page is server-rendered, and every Add to cart / Buy now is a plain
   link to /cart/add — which is the one thing that behaves consistently on
   this store, where theme components and cart apps both intercept product
   forms and buttons.
   ------------------------------------------------------------------ */

(function () {
  'use strict';

  var currency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  var fmt;
  try {
    fmt = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: currency,
    });
  } catch (e) {
    fmt = null;
  }

  function money(cents) {
    var v = (cents || 0) / 100;
    return fmt ? fmt.format(v) : '$' + v.toFixed(2);
  }

  function on(el, evt, fn) {
    if (el) el.addEventListener(evt, fn);
  }


  /* --------------------------------------------------- AMP Slide Cart

   * AMP Slide Cart is this store's cart. It exposes SLIDECART_OPEN /
   * SLIDECART_UPDATE / SLIDECART_APPLY_DISCOUNT as globals, so after an ajax add
   * the right move is to refresh it and slide it out — NOT to navigate to /cart,
   * which dumps the shopper on the stock cart template that the redesign does not
   * style. Navigation stays as the fallback for when the app is absent.
   *
   * Discount codes are applied with a plain fetch to /discount/<code>: verified to
   * attach the code to the cart with no page load.
   */
  function applyDiscount(code) {
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code), { redirect: 'follow' }).catch(function () {});
  }

  function revealCart(fallbackUrl) {
    var hasDrawer =
      typeof window.SLIDECART_OPEN === 'function' && typeof window.SLIDECART_UPDATE === 'function';

    if (!hasDrawer) {
      window.location.href = fallbackUrl || '/cart';
      return;
    }

    Promise.resolve()
      .then(function () {
        return window.SLIDECART_UPDATE();
      })
      .then(function () {
        return window.SLIDECART_OPEN();
      })
      .catch(function () {
        window.location.href = fallbackUrl || '/cart';
      });
  }

  function initByo(root) {
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-prv2-byo-opt]'));
    var linesEl = root.querySelector('[data-prv2-byo-lines]');
    var emptyEl = root.querySelector('[data-prv2-byo-empty]');
    var subtotalEl = root.querySelector('[data-prv2-byo-subtotal]');
    var discountRow = root.querySelector('[data-prv2-byo-discountrow]');
    var discountEl = root.querySelector('[data-prv2-byo-discount]');
    var totalEl = root.querySelector('[data-prv2-byo-total]');
    var nudgeEl = root.querySelector('[data-prv2-byo-nudge]');
    var addBtn = root.querySelector('[data-prv2-byo-add]');
    var buyBtn = root.querySelector('[data-prv2-byo-buynow]');
    var tierChips = document.querySelectorAll('[data-prv2-tier]');

    if (!opts.length || !addBtn) return;

    var tiersOn = root.getAttribute('data-tiers-on') === 'true';
    var cartAdd = root.getAttribute('data-cart-add') || '/cart/add';

    var rates = {
      2: parseInt(root.getAttribute('data-tier2'), 10) || 0,
      3: parseInt(root.getAttribute('data-tier3'), 10) || 0,
      4: parseInt(root.getAttribute('data-tier4'), 10) || 0,
    };
    var codes = {
      2: root.getAttribute('data-code2') || '',
      3: root.getAttribute('data-code3') || '',
      4: root.getAttribute('data-code4') || '',
    };

    var current = { items: [], code: '' };

    var qtyOf = function (o) {
      return parseInt(o.getAttribute('data-qty'), 10) || 0;
    };
    var priceOf = function (o) {
      return parseInt(o.getAttribute('data-price'), 10) || 0;
    };

    /*
     * The tier is driven by TOTAL bottles, not distinct products, because that is
     * what the Shopify codes enforce: BUNDLE15/25/30 carry a minimum ITEM
     * QUANTITY of 2/3/4. Three of the same black tank treatment therefore earns
     * 25%, and the panel has to agree with what checkout will charge.
     */
    function tierFor(n) {
      if (n >= 4) return 4;
      if (n === 3) return 3;
      if (n === 2) return 2;
      return 0;
    }

    function setQty(o, n) {
      n = Math.max(0, Math.min(20, n));
      o.setAttribute('data-qty', n);
      o.setAttribute('data-selected', n > 0 ? 'true' : 'false');

      var toggle = o.querySelector('[data-prv2-byo-toggle]');
      var stepper = o.querySelector('[data-prv2-byo-qty]');
      var count = o.querySelector('[data-prv2-byo-count]');
      var check = o.querySelector('[data-prv2-byo-check]');
      var accent = o.getAttribute('data-accent') || '';

      if (toggle) toggle.setAttribute('aria-pressed', n > 0 ? 'true' : 'false');
      if (stepper) stepper.hidden = n === 0;
      if (count) count.textContent = n;
      o.style.borderColor = n > 0 && accent ? accent : '';
      if (check) {
        check.style.background = n > 0 && accent ? accent : '';
        check.style.color = n > 0 ? '#fff' : 'transparent';
      }
    }

    function render() {
      var picked = opts.filter(function (o) {
        return qtyOf(o) > 0;
      });

      var totalQty = 0;
      var subtotal = 0;
      var discount = 0;
      var tier = 0;
      var rate = 0;

      picked.forEach(function (o) {
        totalQty += qtyOf(o);
        subtotal += priceOf(o) * qtyOf(o);
      });

      tier = tiersOn ? tierFor(totalQty) : 0;
      rate = tier ? rates[tier] : 0;

      // Shopify floors the discount PER UNIT and then multiplies by quantity.
      // Measured: 3 x $29.99 at 30% is charged 3 x floor(2999*0.30) = 2697,
      // not floor(8997*0.30) = 2699. Flooring the line total quoted $81.88
      // against a real cart of $81.90.
      picked.forEach(function (o) {
        discount += Math.floor((priceOf(o) * rate) / 100) * qtyOf(o);
      });

      var total = subtotal - discount;

      linesEl.querySelectorAll('[data-prv2-byo-line]').forEach(function (el) {
        el.remove();
      });

      picked.forEach(function (o) {
        var row = document.createElement('div');
        row.className = 'prv2-byo__line';
        row.setAttribute('data-prv2-byo-line', '');

        var name = document.createElement('span');
        var q = qtyOf(o);
        name.textContent = (o.getAttribute('data-name') || '') + (q > 1 ? ' × ' + q : '');

        var amt = document.createElement('span');
        amt.textContent = money(priceOf(o) * q);

        row.appendChild(name);
        row.appendChild(amt);
        linesEl.insertBefore(row, emptyEl);
      });

      if (emptyEl) emptyEl.hidden = picked.length > 0;
      if (subtotalEl) subtotalEl.textContent = money(subtotal);
      if (totalEl) totalEl.textContent = money(total);

      if (discountRow) {
        if (discount > 0) {
          discountRow.hidden = false;
          if (discountEl) discountEl.textContent = '-' + money(discount);
        } else {
          discountRow.hidden = true;
        }
      }

      tierChips.forEach(function (chip) {
        chip.setAttribute(
          'data-active',
          String(tierFor(totalQty)) === chip.getAttribute('data-prv2-tier') ? 'true' : 'false'
        );
      });

      if (nudgeEl) {
        if (!tiersOn) {
          if (totalQty > 1) {
            nudgeEl.hidden = false;
            nudgeEl.setAttribute('data-tier', 'low');
            nudgeEl.textContent = totalQty + ' bottles, one order, one shipment.';
          } else {
            nudgeEl.hidden = true;
          }
        } else if (rate > 0) {
          var nextTier = tierFor(totalQty + 1);
          var nextRate = nextTier ? rates[nextTier] : 0;
          nudgeEl.hidden = false;
          nudgeEl.setAttribute('data-tier', rate >= rates[3] ? 'high' : 'low');
          nudgeEl.textContent =
            nextRate > rate
              ? 'Add 1 more to jump from ' + rate + '% to ' + nextRate + '% off your bundle.'
              : rate + '% off your bundle.';
        } else if (totalQty === 1) {
          nudgeEl.hidden = false;
          nudgeEl.setAttribute('data-tier', 'low');
          nudgeEl.textContent = 'Add 1 more to take ' + rates[2] + '% off your bundle.';
        } else {
          nudgeEl.hidden = true;
        }
      }

      [addBtn, buyBtn].forEach(function (btn, idx) {
        if (!btn) return;
        if (totalQty === 0) {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('href', '#prv2-byo');
          btn.style.opacity = '0.55';
          btn.style.pointerEvents = 'none';
        } else {
          btn.removeAttribute('aria-disabled');
          btn.style.opacity = '';
          btn.style.pointerEvents = '';
          btn.setAttribute(
            'href',
            cartAdd +
              '?id=' + encodeURIComponent(picked[0].getAttribute('data-variant')) +
              '&quantity=' + qtyOf(picked[0]) +
              '&return_to=' + (idx === 1 ? '/checkout' : '/cart')
          );
        }
      });

      current = {
        items: picked.map(function (o) {
          return { id: Number(o.getAttribute('data-variant')), quantity: qtyOf(o) };
        }),
        code: tiersOn && tier ? codes[tier] : '',
      };
    }

    function submitBundle(e, landing) {
      if (!current.items.length) {
        e.preventDefault();
        return;
      }
      if (!window.fetch) return; // fall through to the single-item href

      e.preventDefault();
      var btn = e.currentTarget;
      btn.style.pointerEvents = 'none';
      var restore = btn.textContent;
      btn.textContent = 'Adding…';

      var code = current.code;
      var navFallback = code
        ? '/discount/' + encodeURIComponent(code) + '?redirect=' + landing
        : landing;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: current.items }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return applyDiscount(code);
        })
        .then(function () {
          if (landing.indexOf('/checkout') === 0) {
            window.location.href = landing;
            return;
          }
          btn.style.pointerEvents = '';
          btn.textContent = restore;
          revealCart(navFallback);
        })
        .catch(function () {
          btn.style.pointerEvents = '';
          btn.textContent = restore;
          window.location.href = navFallback;
        });
    }

    addBtn.addEventListener('click', function (e) {
      submitBundle(e, '/cart');
    });
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        submitBundle(e, '/checkout');
      });
    }

    opts.forEach(function (o) {
      var toggle = o.querySelector('[data-prv2-byo-toggle]');
      var dec = o.querySelector('[data-prv2-byo-dec]');
      var inc = o.querySelector('[data-prv2-byo-inc]');

      on(toggle, 'click', function () {
        setQty(o, qtyOf(o) > 0 ? 0 : 1);
        render();
      });
      on(inc, 'click', function () {
        setQty(o, qtyOf(o) + 1);
        render();
      });
      on(dec, 'click', function () {
        // stepping below one removes the bottle from the bundle
        setQty(o, qtyOf(o) - 1);
        render();
      });

      setQty(o, qtyOf(o));
    });

    render();
  }

  /* ------------------------------------------------------- mobile dots */

  /*
   * The card rows are CSS scroll-snap carousels under 750px (see
   * prv2-home.css). This adds the dot indicators the live site's Swiper row
   * has, without pulling in Swiper: the container is already scrollable and
   * accessible on its own, so if this never runs the carousel still works.
   */
  function initCarousel(row) {
    if (row.dataset.prv2DotsReady) return;
    row.dataset.prv2DotsReady = '1';

    var cards = Array.prototype.slice.call(row.children);
    if (cards.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'prv2-dots';
    dots.setAttribute('role', 'tablist');
    dots.setAttribute('aria-label', 'Choose a card');

    cards.forEach(function (card, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Go to item ' + (i + 1) + ' of ' + cards.length);
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.addEventListener('click', function () {
        row.scrollTo({ left: card.offsetLeft - row.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    row.parentNode.insertBefore(dots, row.nextSibling);

    function setActive(i) {
      Array.prototype.forEach.call(dots.children, function (b, j) {
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    // IntersectionObserver rather than a scroll handler: it reports the card
    // actually centred in the scroller without depending on scroll events
    // firing, and it costs nothing while the row is off screen.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          var best = null;
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            if (!best || e.intersectionRatio > best.intersectionRatio) best = e;
          });
          if (!best) return;
          var i = cards.indexOf(best.target);
          if (i >= 0) setActive(i);
        },
        { root: row, threshold: [0.5, 0.75, 1] }
      );
      cards.forEach(function (c) {
        io.observe(c);
      });
    } else {
      row.addEventListener(
        'scroll',
        function () {
          var mid = row.scrollLeft + row.clientWidth / 2;
          var best = 0;
          var bestDist = Infinity;
          cards.forEach(function (card, i) {
            var d = Math.abs(card.offsetLeft - row.offsetLeft + card.offsetWidth / 2 - mid);
            if (d < bestDist) {
              bestDist = d;
              best = i;
            }
          });
          setActive(best);
        },
        { passive: true }
      );
    }
  }


  /* ------------------------------------------- cart links -> ajax adds

   * Every card's Add to cart / Buy now is a plain <a href="/cart/add?...">, which
   * works with JS off and avoids the form interceptors on this store. But a GET
   * /cart/add is invisible to Meta: measured on this store, an empty /cart load
   * and a GET-add-then-/cart BOTH leave the pixel at eventCount 1 (the PageView),
   * while an ajax add fires trackShopify -> AddToCart on 1496281468776808.
   *
   * So intercept the click, add through /cart/add.js so the pixel sees it, then
   * follow the link's own return_to. The href stays exactly as rendered, so with
   * JS off the link still works — it just will not be measured, same as now.
   */
  function initCartLinks(scope) {
    (scope || document).querySelectorAll('.prv2 a[href*="/cart/add"]').forEach(function (a) {
      if (a.dataset.prv2CartLink) return;
      if (a.hasAttribute('data-prv2-byo-add') || a.hasAttribute('data-prv2-byo-buynow')) return;
      a.dataset.prv2CartLink = '1';

      a.addEventListener('click', function (e) {
        if (!window.fetch) return;

        var href = a.getAttribute('href') || '';
        var qs;
        try {
          qs = new URLSearchParams(href.split('?')[1] || '');
        } catch (err) {
          return;
        }
        var id = qs.get('id');
        if (!id) return;

        var qty = parseInt(qs.get('quantity'), 10) || 1;
        var dest = qs.get('return_to') || '/cart';

        e.preventDefault();
        var restore = a.textContent;
        a.style.pointerEvents = 'none';
        a.textContent = 'Adding…';

        var body = { items: [{ id: Number(id), quantity: qty }] };
        var plan = qs.get('selling_plan');
        if (plan) body.items[0].selling_plan = Number(plan);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            // Buy now means checkout; Add to cart should show the drawer.
            if (dest.indexOf('/checkout') === 0) {
              window.location.href = dest;
              return;
            }
            a.style.pointerEvents = '';
            a.textContent = restore;
            revealCart(dest);
          })
          .catch(function () {
            a.style.pointerEvents = '';
            a.textContent = restore;
            window.location.href = href; // let Shopify handle it
          });
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-prv2-byo]').forEach(initByo);
    (scope || document).querySelectorAll('[data-prv2-carousel]').forEach(initCarousel);
    initCartLinks(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
